export const actionTypes = {
  REQUEST_START: 'TAPS.FIAS_ADDRESS.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.FIAS_ADDRESS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.FIAS_ADDRESS.REQUEST_FAILURE',
  RESET_FIAS_ADDRESS: 'TAPS.FIAS_ADDRESS.RESET_DOC_TYPES',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function resetFiasAddress() {
  return {
    type: actionTypes.RESET_FIAS_ADDRESS,
  };
}
